function sortPeopleByLastName(people) {
	// Create an object to store the arrays for each letter
	const sortedPeople = {};

	// Iterate over each person in the array
	for (const person of people) {
	  // Get the first letter of the last name
	  const firstLetter = person.last_name.charAt(0).toUpperCase();
  
	  // If the array for that letter doesn't exist, create it
	  if (!sortedPeople[firstLetter]) {
		sortedPeople[firstLetter] = [];
	  }
  
	  // Push the person object into the appropriate array
	  sortedPeople[firstLetter].push(person);
	}
  
	// Sort each array alphabetically by last name
	for (const letter in sortedPeople) {
	  sortedPeople[letter].sort((a, b) =>
		a.last_name.localeCompare(b.last_name)
	  );
	}
  
	// Create an array to hold the final result
	const result = [];
  
	// Iterate over the keys of the sortedPeople object
	// and create an object with the first letter and the array of people
	for (const letter of Object.keys(sortedPeople).sort()) {
	  const obj = {
		firstLetter: letter,
		people: sortedPeople[letter]
	  };
	  result.push(obj);
	}
  
	return result;
}

export default sortPeopleByLastName;